import { useRightNav } from "@/context/RightNavContext";
import type * as checkout from "@imtbl/checkout-sdk";
import { useQueryClient } from "@tanstack/react-query";
import type { QueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { CommerceWidget } from "../wallet/SideDrawerCommerceWidget";
import { LayerSwap } from "../wallet/SideDrawerLayerswap";
import type { WidgetParams } from "./index";

// Duplicate of WidgetContent.tsx for use in side drawer
// Will eventually replace it

const invalidateBalances = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({
    queryKey: ["coin-balances-zkevm"],
    refetchType: "all",
  });
};

const Content = ({
  widgetParams,
  closeWidget,
}: {
  widgetParams: WidgetParams | null;
  closeWidget: () => void;
}) => {
  const queryClient = useQueryClient();

  const handleSuccess = useCallback(
    (event: checkout.CommerceSuccessEvent) => {
      invalidateBalances(queryClient);
    },
    [queryClient],
  );

  const handleFailure = useCallback(() => {}, []);

  if (!widgetParams) return <></>;

  switch (widgetParams.type) {
    case "CommerceWidgetFlow":
      return (
        <CommerceWidget
          params={widgetParams.params}
          config={widgetParams.config}
          onClose={closeWidget}
          onSuccess={handleSuccess}
          onFailure={handleFailure}
        />
      );
    case "LayerSwap":
      return <LayerSwap userJourney="Balances" />;
    case "CEXDeposit":
      return (
        <LayerSwap
          userJourney="Balances"
          defaultFrom={widgetParams.params.defaultFrom}
        />
      );
  }
};

export const WidgetContent = ({
  widgetParams,
}: {
  widgetParams: WidgetParams | null;
}) => {
  const { openWidgetTab, widgetConfig } = useRightNav();

  const handleCloseWidget = useCallback(() => {
    // Reset the widget by re-navigating to the current tab
    // This triggers the nav state to reset and remount the widget
    if (widgetConfig) {
      openWidgetTab({ ...widgetConfig });
    }
  }, [openWidgetTab, widgetConfig]);

  return (
    <Content widgetParams={widgetParams} closeWidget={handleCloseWidget} />
  );
};
